import React, { useState } from 'react';
import './Contact.css'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
    const form = useRef();
    const [buttonText, setButtonText] = useState('SEND');

    const sendEmail = (e) => {
        e.preventDefault();

        setButtonText('Sending...'); // Change button text when sending

        emailjs.sendForm('service_xroy6gl', 'template_as77nu9', form.current, '6iZQ6M1XHO3-i3ETs')
            .then((result) => {
                console.log(result.text);
                setButtonText('Message Sent'); // Change button text on success
            })
            .catch((error) => {
                console.log(error.text);
                setButtonText('SEND'); // Reset button text on error
            });

        e.target.reset();
    };


  return (
    <section id="contact">
        <div className="contact-container">
            <h1 className='contact-title'>Get In Touch</h1>

            <div className="contact-content">
                <div className="contact-box">
                {/* {showSuccessMessage && (
                            <div className="success-message">
                                Message Sent, We Will Reply Back Shortly
                            </div>
                        )} */}
                    <form ref={form} onSubmit={sendEmail}>
                        <div className="input-row">
                            <div className="input-group">
                                <label>Name</label>
                                <input type="text" name='name' placeholder='Enter Full Name' required/>
                            </div>
                            <div className="input-group">
                                <label>Phone</label>
                                <input type="text" name='phone' placeholder='Enter Phone Number' required/>
                            </div>
                        </div>
                        <div className="input-row">
                            <div className="input-group">
                                <label>Email</label>
                                <input type="email" name='email' placeholder='Enter Email Address' required/>
                            </div>
                            <div className="input-group">
                                <label>Subject</label>
                                <input type="text" name='subject' placeholder='Enter Subject' required/>
                            </div>
                        </div>

                        <label>Message</label>
                        <textarea rows="5" name='message' placeholder='Enter Your Message' required></textarea>

                        <button type="submit" disabled={buttonText === 'Sending...'}>{buttonText}</button>
                    </form>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Contact;